import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from '@valg-shared/components/table/table.module';
import { CdkTableModule } from '@angular/cdk/table';
import { ValgInputModule } from '@valg-shared/components/input/input.module';
import { InputDropdownModule } from '@valg-shared/components/input/input-dropdown/input-dropdown.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExportDataPageComponent } from "./export-data-page.component";
import { BreadcrumbsModule } from "@shared/components/breadcrumbs/breadcrumbs.module";
import { CardModule } from "@valg-shared/components/card/card.module";


@NgModule({
  declarations: [
    ExportDataPageComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    TableModule,
    CdkTableModule,
    ValgInputModule,
    InputDropdownModule,
    FormsModule,
    MatIconModule,
    BreadcrumbsModule,
    CardModule,
    ReactiveFormsModule
  ],
  providers: [
    DecimalPipe
  ]
})
export class ExportDataPageModule { }
